import { render, staticRenderFns } from "./basic-info.vue?vue&type=template&id=340411d2&scoped=true&"
import script from "./basic-info.vue?vue&type=script&lang=js&"
export * from "./basic-info.vue?vue&type=script&lang=js&"
import style0 from "./basic-info.vue?vue&type=style&index=0&id=340411d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "340411d2",
  null
  
)

export default component.exports